import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const authentik = defineConnector({
  identifier: "authentik",
  name: "Authentik",
  tagLine: "Identity provider and SSO",
  logo,
  protocol: "http",
  tags: ["identity"],
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Get your Authentik API token",
      items: [
        {
          kind: "markdown",
          content:
            "In Authentik, go to **Directory > Tokens and App passwords** and create a new API token.",
        },
      ],
    },
    {
      title: "Enter your Authentik details",
      items: [
        {
          kind: "baseUrl",
          label: "Authentik instance URL",
          required: true,
          placeholder: "https://authentik.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Authentik instance.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/api/v3/core/tenants/current/`,
  },
});
